import Grid2 from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

function TutorialLink({ manufacturer, tvHasSat, tvHasIP, matchedTutorials }) {
    const { sat: satTutorial, ip: ipTutorial } = matchedTutorials;

    let linkStyle = {
        width: {
            xs: "100%",
            xsm: "100%",
        },
        textDecoration: "none",
    };

    if (tvHasSat && tvHasIP) {
        linkStyle = Object.assign(linkStyle, {
            width: {
                xs: "100%",
                xsm: "45%",
            },
            marginBottom: {
                xs: "1rem",
                xsm: "0",
            },
        });
    }

    return (
        <Grid2
            xs={12}
            sx={{
                background: "#ECECEC",
                fontSize: "1rem",
                textAlign: "center",
                marginTop: "5rem",
                paddingBottom: "3rem",
            }}
        >
            <Grid2 xs={10} xsOffset={1} sx={{}}>
                <p>
                    Hier das {manufacturer}-Tutorial zur Aktivierung und
                    Verlängerung von HD+ ansehen.
                </p>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: {
                            xs: "column",
                            xsm: "row",
                        },
                    }}
                >
                    {tvHasSat && satTutorial && (
                        <Link href={satTutorial} sx={linkStyle}>
                            <Button
                                variant="outlined"
                                style={{
                                    color: "#202020",
                                    border: "1px solid #202020",
                                    width: "100%",
                                }}
                            >
                                Sat Tutorial
                            </Button>
                        </Link>
                    )}
                    {tvHasIP && ipTutorial && (
                        <Link href={ipTutorial} sx={linkStyle}>
                            <Button
                                variant="outlined"
                                style={{
                                    color: "#202020",
                                    border: "1px solid #202020",
                                    width: "100%",
                                }}
                            >
                                IP Tutorial
                            </Button>
                        </Link>
                    )}
                </Box>
            </Grid2>
        </Grid2>
    );
}

export default TutorialLink;
